export enum MatomoEventCategory {
  AllDictionaries = "All dictionaries",
  ArabicKeyboard = "Arabic keyboard",
  CompactArticle = "CompactArticle",
  CompactFooter = "Compact footer",
  CompanyDictionaryAd = "Company Dictionary Ad",
  CompanyDictionaryPage = "Company Dictionary Page",
  DictionaryUpsell = "Dictionary Upsell",
  DownloadPage = "Download Page",
  FreePage = "Free page",
  ExpandedFooter = "Expanded footer",
  Header = "Frontpage",
  NarrowDictionaries = "Narrow dictionaries",
  News = "News",
  Omnibar = "Omnibar",
  Results = "Results",
  Search = "Search",
  SubscriptionPage = "Subscription page",
  SubscriptionPageBusiness = "Subscription - Business",
  SupportPage = "Support",
  WriteAssistantPromotion = "WriteAssistant Promotion"
}

export enum MatomoEventAction {
  AddFavorite = "Added favorite",
  ArticlesExpandToggled = "Articles expand toggled",
  ArabicKeyboard = "Arabic keyboard",
  ArticleExpanded = "Article expanded",
  ClickAssistanceOptions = "Clicked assistance options",
  ClickBannerLink = "Clicked banner link",
  ClickBrowserExtension = "Clicked Browser extension",
  ClickCallToAction = "Clicked call to action",
  ClickClose = "Clicked close",
  ClickDesktopApp = "Clicked Desktop app",
  ClickDictionaryJumpToastSetting = "Clicked dictionary jump toast setting",
  ClickDictionaryJumpToastSettingCancel = "Clicked dictionary jump toast setting cancel",
  ClickDontShowAgain = "Checked Don't show checkbox",
  ClickFooterButton = "Clicked footer button",
  ClickedExtension = "Clicked Extension",
  ClickedToCopyTranslation = "Clicked a translation to copy",
  ClickFaqItemBusiness = "Clicked FAQ item - Business",
  ClickFaqItemPrivate = "Clicked FAQ item - Private user",
  ClickFaqItemSchool = "Clicked FAQ item - School",
  ClickFuzzySuggestion = "Clicked fuzzy suggestion",
  ClickGetAccess = "Clicked get access",
  ClickGetAccessBox = "Clicked get access box",
  ClickGetMoreInformation = "Clicked get more information",
  ClickHeaderButton = "Clicked header button",
  ClickMobileApp = "Clicked Mobile app",
  ClickPronunciation = "Clicked to hear pronunciation",
  ClickSearchIcon = "Clicked search icon",
  ClickSearchToolboxIcon = "Clicked search toolbox icon",
  ClickShowContent = "Clicked show content",
  DoubleClickTranslation = "Double clicked translation",
  FormSubmit = "Form submitted",
  FuzzyResultShown = "Fuzzy result page shown",
  HitEnterToSearch = "Hit enter to search",
  OpenAllDictionaries = "Open all dictionaries",
  OpenInflectionScheme = "Opened inflection scheme",
  OpenNarrowDictionarySelector = "Open narrow dictionaries",
  OpenNewsCard = "Opened news card",
  OpenOmnibar = "Open Omnibar via Keyboard",
  PickDictionaryInOmnibar = "Picked dictionary in omnibar",
  PickContactUs = 'Picked "contact us"',
  PickCompanySolution = "Picked company solution",
  PickFlexibleSolution = "Picked flexible solution",
  PickIndividualSolution = "Picked individual solution",
  PickLanguageFrom = "Picked language-from",
  PickLanguageTo = "Picked language-to",
  PickSuggestion = "Used wordcompletion or suggestions in dropdown",
  RemoveFavorite = "Removed favorite",
  ResetLanguageSelector = "Reset language selector",
  RevertDictionaryJump = "Clicked return on Change Dictionary toast",
  SearchWithLanguageSelector = "Searched with active language selector",
  SearchWithoutLanguageSelector = "Searched without language selector",
  SelectDictionaryAll = "Picked dictionary in all dictionaries",
  SelectDictionaryNarrow = "Picked dictionary in narrow dictionaries",
  SelectDictionaryTopResults = "Picked dictionary in top results",
  SelectUpsellDictionaryTopResults = "Clicked upsell dictionary in top results",
  SubmitDictionaryJumpToastSetting = "Submitted dictionary jump toast setting",
  ToastDisplayed = "Toast displayed",
  ToggleDictionaryJumpToastSetting = "Toggled dictionary jump toast setting"
}
